/**
 * @generated SignedSource<<0081f9eb519e05f9009f739803614b1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
export type AccountEditSetRoleMutation$variables = {
  id: string;
  role: Roles;
  storeId?: string | null;
};
export type AccountEditSetRoleMutation$data = {
  readonly store: {
    readonly storeUser: {
      readonly setRole: {
        readonly id: string;
        readonly role: Roles;
      };
    } | null;
  };
};
export type AccountEditSetRoleMutation = {
  response: AccountEditSetRoleMutation$data;
  variables: AccountEditSetRoleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "role"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "StoreUserMutation",
        "kind": "LinkedField",
        "name": "storeUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "role",
                "variableName": "role"
              }
            ],
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "setRole",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountEditSetRoleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountEditSetRoleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ac4fb79c9e3704da6a0c21f3b378991c",
    "id": null,
    "metadata": {},
    "name": "AccountEditSetRoleMutation",
    "operationKind": "mutation",
    "text": "mutation AccountEditSetRoleMutation(\n  $id: ID!\n  $role: Roles!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    storeUser(id: $id) {\n      setRole(role: $role) {\n        id\n        role\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6173a193eaa00d3e6bdc5ab57264e1fc";

export default node;
